const IMPERSONATION_COOKIE = 'fl_impersonation';

export function isImpersonationSession(): boolean {
  return document.cookie
    .split(';')
    .some((c) => c.trim().startsWith(`${IMPERSONATION_COOKIE}=true`));
}

export function setImpersonationCookie(): void {
  document.cookie = `${IMPERSONATION_COOKIE}=true; path=/; SameSite=Lax`;
}

export function clearImpersonationCookie(): void {
  document.cookie = `${IMPERSONATION_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
